export const HEADER_CTA_TEXT = 'Contact our production team';
export const HEADER_CTA_TEXT_MOBILE = 'Contact our team';
